<template>
  <div class="fee-receipt-container">
    <!-- 查询条件 -->
    <el-card class="search-wrapper">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('feeReceipt.search.title') }}</span>
        <el-button type="text" style="float: right; padding: 3px 0" @click="_moreCondition">
          {{ feeReceiptManageInfo.moreCondition ? $t('common.hide') : $t('common.more') }}
        </el-button>
      </div>
      <el-row :gutter="15">
        <el-col :span="6">
          <el-input v-model="feeReceiptManageInfo.conditions.receiptCode" placeholder="收据编号"
            clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="feeReceiptManageInfo.conditions.roomId" :placeholder="$t('feeReceipt.search.roomId')"
            clearable />
        </el-col>
        <el-col :span="6">
          <el-select v-model="feeReceiptManageInfo.conditions.objType" :placeholder="$t('feeReceipt.search.objType')"
            style="width:100%">
            <el-option :label="$t('feeReceipt.search.all')" value="" />
            <el-option :label="$t('feeReceipt.search.houseFee')" value="3333" />
            <el-option :label="$t('feeReceipt.search.parkingFee')" value="6666" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="feeReceiptManageInfo.conditions.receiptType" placeholder="票据类型"
            style="width:100%" clearable>
            <el-option label="全部" value="" />
            <el-option label="机打收据" value="machine" />
            <el-option label="手写收据" value="hand" />
            <el-option label="发票" value="invoice" />
          </el-select>
        </el-col>
      </el-row>

      <el-row :gutter="15" style="margin-top:15px">
        <el-col :span="6">
          <el-select v-model="feeReceiptManageInfo.conditions.statusCd" placeholder="状态"
            style="width:100%" clearable>
            <el-option label="全部" value="" />
            <el-option label="正常" value="0" />
            <el-option label="已作废" value="2002" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="feeReceiptManageInfo.conditions.qstartTime" type="date"
            :placeholder="$t('feeReceipt.search.startTime')" style="width:100%" />
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="feeReceiptManageInfo.conditions.qendTime" type="date"
            :placeholder="$t('feeReceipt.search.endTime')" style="width:100%" />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="_queryFeeReceiptMethod">
            <i class="el-icon-search"></i>
            {{ $t('common.search') }}
          </el-button>
          <el-button @click="_resetFeeReceiptMethod">
            <i class="el-icon-refresh"></i>
            {{ $t('common.reset') }}
          </el-button>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top:20px">
        <el-col :span="6">
          <el-date-picker v-model="feeReceiptManageInfo.conditions.qstartTime" type="date"
            :placeholder="$t('feeReceipt.search.startTime')" style="width:100%" />
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="feeReceiptManageInfo.conditions.qendTime" type="date"
            :placeholder="$t('feeReceipt.search.endTime')" style="width:100%" />
        </el-col>
      </el-row>
    </el-card>

    <!-- 收据信息 -->
    <el-card class="list-wrapper">
      <div slot="header" class="flex justify-between receipt-list-header">
        <span>{{ $t('feeReceipt.list.title') }}</span>
        <div class="header-actions">
          <el-input v-model="batchEditInfo.oldReceiptCode" placeholder="输入要修改的旧收据号"
            clearable style="width:220px;margin-right:10px;" />
          <el-button type="warning" icon="el-icon-edit" @click="_openBatchEditReceipt">
            批量修改收据号
          </el-button>
        </div>
      </div>

      <el-table v-loading="loading" :data="groupedReceipts" border style="width: 100%" row-key="receiptCode">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table :data="scope.row.details" border size="mini" style="width: 95%; margin: 8px auto;">
              <el-table-column prop="feeName" :label="$t('feeReceipt.table.detailFeeName')" align="center" />
              <el-table-column prop="roomName" :label="$t('feeReceipt.table.roomName')" align="center" />
              <el-table-column prop="carNum" :label="$t('feeReceipt.table.carNum')" align="center" />
              <el-table-column :label="$t('feeReceipt.table.detailAmount')" align="center">
                <template slot-scope="s">{{ s.row.detailAmount || s.row.amount }}</template>
              </el-table-column>
              <el-table-column prop="createTime" :label="$t('feeReceipt.table.createTime')" align="center" />
              <el-table-column prop="statusCd" :label="$t('feeReceipt.table.state')" align="center" width="80">
                <template slot-scope="s">
                  <el-tag v-if="s.row.statusCd === '2002'" type="danger" size="mini">{{ $t('feeReceipt.status.voided') }}</el-tag>
                  <el-tag v-else-if="s.row.statusCd === '1001'" type="warning" size="mini">预收</el-tag>
                  <el-tag v-else type="success" size="mini">{{ $t('feeReceipt.status.normal') }}</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="receiptCode" :label="$t('feeReceipt.table.receiptCode')" align="center">
          <template slot-scope="scope">
            {{ scope.row.receiptCode || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="objType" :label="$t('feeReceipt.table.objType')" align="center">
          <template slot-scope="scope">
            {{ scope.row.objType === '3333' ? $t('feeReceipt.search.houseFee') : $t('feeReceipt.search.parkingFee') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('feeReceipt.table.itemCount')" align="center" width="80">
          <template slot-scope="scope">
            {{ scope.row.detailCount }}
          </template>
        </el-table-column>
        <el-table-column prop="roomName" :label="$t('feeReceipt.table.roomName')" align="center" />
        <el-table-column prop="payObjName" :label="$t('feeReceipt.table.payObjName')" align="center" />
        <el-table-column prop="carNum" :label="$t('feeReceipt.table.carNum')" align="center" />
        <el-table-column prop="totalAmount" :label="$t('feeReceipt.table.amount')" align="center" />
        <el-table-column :label="'票据类型'" align="center" width="90">
          <template slot-scope="scope">
            <el-tag size="mini" :type="_receiptTypeTag(scope.row.receiptType)">{{ _receiptTypeName(scope.row.receiptType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('feeReceipt.table.createTime')" align="center" />
        <el-table-column :label="$t('feeReceipt.table.state')" align="center" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.statusCd === '1001'" type="warning" size="mini">预收</el-tag>
            <el-tag v-else-if="scope.row.voidedCount === scope.row.detailCount" type="danger" size="mini">{{ $t('feeReceipt.status.voided') }}</el-tag>
            <el-tag v-else-if="scope.row.voidedCount > 0" type="warning" size="mini">{{ scope.row.voidedCount }}/{{ scope.row.detailCount }} {{ $t('feeReceipt.status.voided') }}</el-tag>
            <el-tag v-else type="success" size="mini">{{ $t('feeReceipt.status.normal') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="280">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="_printFeeReceipt(scope.row)">
              {{ $t('feeReceipt.button.reprint') }}
            </el-button>
            <el-button v-if="scope.row.voidedCount < scope.row.detailCount" size="mini" type="danger"
              @click="_voidFeeReceipt(scope.row)">
              {{ $t('feeReceipt.button.void') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page.current" :page-sizes="[50, 100, 200]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-card>

    <!-- 批量修改收据号（把公众号自缴生成的收据号直接改成发票号） -->
    <el-dialog title="批量修改收据号" :visible.sync="batchEditVisible" width="640px" @open="_onBatchEditOpen">
      <el-alert type="info" :closable="false" style="margin-bottom:15px;">
        将把系统中所有"旧收据号"对应的缴费记录一次性改为新收据号/发票号，包括该收据号下的所有明细。
      </el-alert>
      <el-form :model="batchEditInfo" label-width="120px">
        <el-form-item label="旧收据号">
          <el-input v-model="batchEditInfo.oldReceiptCode" placeholder="公众号自缴自动生成的缴款单号（可与上方列表查询框联动填入）" clearable />
        </el-form-item>
        <el-form-item label="新收据号" required>
          <el-input v-model="batchEditInfo.newReceiptCode" placeholder="直接把收据号改成发票号" clearable />
        </el-form-item>
        <el-form-item label="票据类型">
          <el-select v-model="batchEditInfo.receiptType" placeholder="可不选，保持原类型" clearable style="width:100%">
            <el-option label="机打收据" value="machine" />
            <el-option label="手写收据" value="hand" />
            <el-option label="发票" value="invoice" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchEditVisible = false">取消</el-button>
        <el-button type="primary" :loading="batchEditLoading" @click="_submitBatchEdit">确定修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryFeeReceipt, voidFeeReceipt, listFeePrintPage, batchUpdateByReceiptCode } from '@/api/fee/feeReceiptApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'FeeReceiptList',
  data() {
    return {
      loading: false,
      batchEditVisible: false,
      batchEditLoading: false,
      batchEditInfo: {
        oldReceiptCode: '',
        newReceiptCode: '',
        receiptType: ''
      },
      feeReceiptManageInfo: {
        feeReceipts: [],
        moreCondition: false,
        printUrl: '/#/pages/property/printPayFee',
        conditions: {
          objType: '',
          receiptType: '',
          storeName: '',
          objId: '',
          month: '',
          qstartTime: '',
          qendTime: '',
          type: '',
          roomId: '',
          communityId: getCommunityId(),
          receiptCode: '',
          statusCd: '',
          page: 1,
          row: 10
        }
      },
      page: {
        current: 1,
        size: 50,
        total: 0
      }
    }
  },
  created() {
    const now = new Date()
    const y = now.getFullYear()
    this.feeReceiptManageInfo.conditions.qstartTime = `${y}-01-01`
    this.feeReceiptManageInfo.conditions.qendTime = `${y}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`
    this._listFeeReceipts()
    this._listFeePrintPages()
  },
  computed: {
    groupedReceipts() {
      const raw = this.feeReceiptManageInfo.feeReceipts
      if (!raw || raw.length === 0) return []
      // 数据加载时已过滤预收票据(statusCd=1001)，此处不再处理
      const map = new Map()
      raw.forEach(row => {
        const key = row.receiptCode || row.receiptId
        if (!map.has(key)) {
          map.set(key, {
            receiptCode: row.receiptCode,
            receiptId: row.receiptId,
            receiptType: row.receiptType,
            objType: row.objType,
            roomName: row.roomName,
            payObjName: row.payObjName,
            carNum: row.carNum,
            statusCd: row.statusCd,
            createTime: row.createTime,
            totalAmount: 0,
            detailCount: 0,
            voidedCount: 0,
            details: []
          })
        }
        const group = map.get(key)
        group.details.push(row)
        group.detailCount++
        // 金额按明细级累加：detailAmount 是每条明细的金额(SQL: frd.amount)，
        // amount 是收据级总额(INNER JOIN 后每行相同)，用 amount 会把同一收据的 N 条明细累加成 N 倍
        group.totalAmount = (parseFloat(group.totalAmount) + parseFloat(row.detailAmount || row.amount || 0)).toFixed(2)
        // 统计已作废的明细数
        if (row.statusCd === '2002') {
          group.voidedCount++
        }
        // 主行状态：全部作废才算作废（方便用户知道哪些还有未处理的）
        // 取多数状态，优先取 "0"（还有未作废的）
        if (row.statusCd === '0') {
          group.statusCd = '0'
        }
        // 优先取房屋类型的收款人/房号/车位信息
        if (row.objType === '3333' && group.objType === '6666') {
          group.roomName = row.roomName
          group.payObjName = row.payObjName
        }
        if (!group.roomName && row.roomName) {
          group.roomName = row.roomName
        }
        if (!group.payObjName && row.payObjName) {
          group.payObjName = row.payObjName
        }
        if (!group.carNum && row.carNum) {
          group.carNum = row.carNum
        }
      })
      return Array.from(map.values())
    }
  },
  methods: {
    async _listFeeReceipts() {
      try {
        this.loading = true
        const params = {
          ...this.feeReceiptManageInfo.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await queryFeeReceipt(params)
        // 预收票据(statusCd=1001)不展示在补打收据界面，过滤掉
        const filtered = (data || []).filter(r => r.statusCd !== '1001')
        const preCount = (data || []).length - filtered.length
        this.feeReceiptManageInfo.feeReceipts = filtered
        // 修正总数：减去本页被过滤的预收票据数（近似，避免分页显示偏大）
        this.page.total = Math.max(0, (total || 0) - preCount)
      } catch (error) {
        this.$message.error(this.$t('feeReceipt.fetchError'))
      } finally {
        this.loading = false
      }
    },
    async _listFeePrintPages() {
      try {
        const params = {
          page: 1,
          row: 1,
          state: 'T',
          communityId: getCommunityId()
        }
        const { data } = await listFeePrintPage(params)
        if (data && data.length > 0) {
          this.feeReceiptManageInfo.printUrl = data[0].url
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryFeeReceiptMethod() {
      this.page.current = 1
      this._listFeeReceipts()
    },
    _resetFeeReceiptMethod() {
      this.feeReceiptManageInfo.conditions = {
        ...this.feeReceiptManageInfo.conditions,
        objType: '',
        receiptType: '',
        roomId: '',
        receiptCode: '',
        qstartTime: '',
        qendTime: '',
        statusCd: ''
      }
      this._listFeeReceipts()
    },
    _printFeeReceipt(receipt) {
      // 同一收据号(receiptCode)下可能有多张 fee_receipt（批量缴费每条费用一张，receiptId 不同），
      // 必须把同一单据号下的所有 receiptId 都传给打印页，否则只会打印第一张
      // （与 _voidFeeReceipt 逻辑一致：同一个 receiptCode 一起处理）
      const receiptIds = []
      ;(receipt.details || []).forEach(d => {
        if (d.receiptId && receiptIds.indexOf(d.receiptId) === -1) receiptIds.push(d.receiptId)
      })
      // 切换为合并打印 merge=ON，使打印页跨多张 fee_receipt 自动合并同名费用
      const url = `${this.feeReceiptManageInfo.printUrl}?receiptIds=${receiptIds.join(',')}&merge=ON`
      window.open(url)
    },
    _printFeeSmallReceipt(receipt) {
      window.open(`/#/pages/property/printSmallPayFee?receiptIds=${receipt.receiptId}`)
    },
    _voidFeeReceipt(receipt) {
      // 同一个单据号(receiptCode)下可能有多张 fee_receipt（批量缴费每条费用一张，receiptId 不同）
      // 作废时要把这个单据号下所有 receiptId 都作废+退费，不能只作废第一条
      const receiptIds = []
      ;(receipt.details || []).forEach(d => {
        if (d.receiptId && receiptIds.indexOf(d.receiptId) === -1) receiptIds.push(d.receiptId)
      })
      if (receiptIds.length === 0) {
        this.$message.warning(this.$t('feeReceipt.voidError'))
        return
      }
      this.$confirm(this.$t('feeReceipt.confirmVoid'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        let ok = 0
        let fail = 0
        for (const rid of receiptIds) {
          try {
            const res = await voidFeeReceipt({ receiptId: rid })
            if (res && res.code === 0) { ok++ } else { fail++ }
          } catch (error) {
            console.error('作废失败 receiptId=' + rid, error)
            fail++
          }
        }
        if (fail === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
        } else {
          this.$message.warning(`作废完成：成功 ${ok} 条，失败 ${fail} 条`)
        }
        this._listFeeReceipts()
      }).catch(() => {})
    },
    _moreCondition() {
      this.feeReceiptManageInfo.moreCondition = !this.feeReceiptManageInfo.moreCondition
    },
    // 打开批量修改收据号弹窗（保留用户在 header 输入框已输入的值；仅当没填时才用查询条件预填）
    _openBatchEditReceipt() {
      if (!(this.batchEditInfo.oldReceiptCode || '').trim()) {
        this.batchEditInfo.oldReceiptCode = this.feeReceiptManageInfo.conditions.receiptCode || ''
      }
      this.batchEditInfo.newReceiptCode = ''
      this.batchEditInfo.receiptType = ''
      this.batchEditVisible = true
    },
    _onBatchEditOpen() {
      // 进入弹窗时不重置 oldReceiptCode，保留用户在 header 区已输入的旧收据号
      // （仅当用户没填时才用查询条件预填）
      if (!(this.batchEditInfo.oldReceiptCode || '').trim()) {
        this.batchEditInfo.oldReceiptCode = this.feeReceiptManageInfo.conditions.receiptCode || ''
      }
    },
    // 提交批量修改收据号
    _submitBatchEdit() {
      const oldCode = (this.batchEditInfo.oldReceiptCode || '').trim()
      const newCode = (this.batchEditInfo.newReceiptCode || '').trim()
      if (!oldCode) {
        this.$message.warning('请输入要修改的旧收据号')
        return
      }
      if (!newCode) {
        this.$message.warning('请输入新收据号/发票号')
        return
      }
      if (oldCode === newCode) {
        this.$message.warning('新旧收据号不能相同')
        return
      }
      this.$confirm(`确定要把收据号【${oldCode}】下的所有缴费记录批量修改为新收据号/发票号【${newCode}】吗？`, '批量修改收据号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.batchEditLoading = true
        try {
          const params = {
            receiptCodeForBatch: oldCode,
            receiptCode: newCode
          }
          if (this.batchEditInfo.receiptType) {
            params.receiptType = this.batchEditInfo.receiptType
          }
          const res = await batchUpdateByReceiptCode(params)
          // 兼容后端 code 为 0 或字符串 "0" 等情况
          if (res && (res.code === 0 || res.code === '0' || Number(res.code) === 0)) {
            this.$notify({
              title: '更新成功',
              message: `已把收据号【${oldCode}】批量修改为【${newCode}】，共更新 ${res.data || 0} 条记录`,
              type: 'success',
              duration: 3000,
              position: 'top-right'
            })
            // 先关闭弹窗再刷新，避免弹窗遮罩挡住 loading 状态
            this.batchEditVisible = false
            this.batchEditLoading = false
            // 若查询框里是旧的收据号，刷新后把输入框也更新为新的收据号
            if (this.feeReceiptManageInfo.conditions.receiptCode === oldCode) {
              this.feeReceiptManageInfo.conditions.receiptCode = newCode
            }
            // 关闭弹窗后立即刷新列表
            this._listFeeReceipts()
          } else {
            this.$message.error((res && res.msg) || '批量修改失败')
          }
        } catch (error) {
          console.error('批量修改收据号失败:', error)
          this.$message.error('批量修改失败，请稍后重试')
        } finally {
          this.batchEditLoading = false
        }
      }).catch(() => {})
    },
    // 票据类型显示
    _receiptTypeName(type) {
      if (type === 'hand') return '手写收据'
      if (type === 'invoice') return '发票'
      return '机打收据'
    },
    _receiptTypeTag(type) {
      if (type === 'hand') return 'warning'
      if (type === 'invoice') return 'success'
      return ''  // 机打 默认色
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listFeeReceipts()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listFeeReceipts()
    }
  }
}
</script>

<style lang="scss" scoped>
.fee-receipt-container {
  padding: 20px;

  .search-wrapper {
    margin-bottom: 20px;

    .el-row {
      margin-bottom: 0;
    }
  }

  .list-wrapper {
    .receipt-list-header {
      align-items: center;
      .header-actions {
        display: flex;
        align-items: center;
      }
    }
    .el-pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>